/* ==========================================================================
   WAITYX — moteur du tiroir panier natif
   Reproduit le panier concu dans Kaching Cart, sans dependance a l'application.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.WXCartConfig || {};
  var ROOT_URL = (CFG.rootUrl || '/').replace(/\/+$/, '') + '/';
  var T = CFG.texts || {};

  // --------------------------------------------------------------- utilitaires
  function u(path) { return ROOT_URL + path.replace(/^\/+/, ''); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function money(cents) {
    var n = Math.round(Number(cents) || 0) / 100;
    var neg = n < 0;
    var parts = Math.abs(n).toFixed(2).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (neg ? '-' : '') + int + ',' + parts[1] + '€';
  }

  function tpl(str, vars) {
    return String(str || '').replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, function (m, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function imgSize(url, size) {
    if (!url) return CFG.noImage || '';
    return String(url).replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + size + 'x$1$2');
  }

  function json(url, opts) {
    var o = opts || {};
    o.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json' }, o.headers || {});
    return fetch(url, o).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) { var e = new Error('cart-error'); e.body = body; throw e; }
        return body;
      });
    });
  }

  // ------------------------------------------------------------------- icones
  var ICONS = {
    close: '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M12.83 1.17L1.17 12.83M1.17 1.17l11.66 11.66" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    minus: '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1.17 7h11.66" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    plus: '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 1.17v11.66M1.17 7h11.66" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12M9 7V5a2 2 0 012-2h2a2 2 0 012 2v2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    tag: '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"/></svg>',
    arrowLeft: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M19 12H5M5 12l7-7M5 12l7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    arrowRight: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M19 12l-7-7M19 12l-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 7h12l1 13a1 1 0 01-1 1H6a1 1 0 01-1-1L6 7z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 10V6a3 3 0 016 0v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };

  // ------------------------------------------------------------------- l'etat
  var state = {
    cart: null,
    products: {},      // handle -> produit JSON
    recs: null,        // recommandations
    busy: false,
    open: false,
    recsForKey: null
  };

  var el = {};        // references DOM

  // -------------------------------------------------------- donnees produit
  function loadProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (state.products[handle]) return Promise.resolve(state.products[handle]);
    return fetch(u('products/' + handle + '.js'))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) state.products[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function loadCartProducts(cart) {
    var handles = [];
    (cart.items || []).forEach(function (i) {
      if (i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });
    return Promise.all(handles.map(loadProduct));
  }

  function variantOf(product, variantId) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) return product.variants[i];
    }
    return null;
  }

  function findVariant(product, options) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < options.length; j++) {
        if (String(v.options[j]) !== String(options[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // ------------------------------------------------------- lignes et totaux
  function isAddon(item) {
    return CFG.addon && String(item.variant_id) === String(CFG.addon.variantId);
  }

  function cartLines() {
    return (state.cart && state.cart.items ? state.cart.items : []).filter(function (i) { return !isAddon(i); });
  }

  function addonLine() {
    var items = (state.cart && state.cart.items) || [];
    for (var i = 0; i < items.length; i++) if (isAddon(items[i])) return items[i];
    return null;
  }

  function compareAtFor(item) {
    var p = state.products[item.handle];
    var v = variantOf(p, item.variant_id);
    var ca = v && v.compare_at_price ? Number(v.compare_at_price) : 0;
    return ca > item.price ? ca : 0;
  }

  function totals() {
    var savings = 0;
    cartLines().forEach(function (i) {
      var ca = compareAtFor(i);
      if (ca) savings += (ca - i.price) * i.quantity;
    });
    savings += Number((state.cart && state.cart.total_discount) || 0);
    return {
      savings: savings,
      subtotal: Number((state.cart && state.cart.total_price) || 0),
      count: (state.cart && state.cart.item_count) || 0
    };
  }

  function displayCount() {
    var n = 0;
    cartLines().forEach(function (i) { n += i.quantity; });
    return n;
  }

  // ------------------------------------------------------------- rendu HTML
  function renderItem(item) {
    var product = state.products[item.handle];
    var ca = compareAtFor(item);
    var pct = ca ? Math.round((ca - item.price) / ca * 100) : 0;
    var hasOptions = product && product.options && product.options.length &&
      !(product.options.length === 1 && String(product.options[0]).toLowerCase() === 'title');

    var optionNames = '';
    var selectors = '';
    if (hasOptions) {
      var names = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      optionNames = '<span class="wx-item__option-names">' + esc(names.join(', ')) + ':</span>';
      var current = (variantOf(product, item.variant_id) || {}).options || [];
      selectors = '<div class="wx-item__variant-selectors">' + names.map(function (name, idx) {
        var values = [];
        product.variants.forEach(function (v) {
          if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
        });
        return '<select class="wx-select" data-wx-variant-select data-key="' + esc(item.key) + '" data-index="' + idx + '" aria-label="' + esc(name) + '">' +
          values.map(function (val) {
            return '<option value="' + esc(val) + '"' + (String(val) === String(current[idx]) ? ' selected' : '') + '>' + esc(val) + '</option>';
          }).join('') + '</select>';
      }).join('') + '</div>';
    }

    var badge = pct > 0
      ? '<span class="wx-badge">' + ICONS.tag + '<span>' + tpl(T.youSave || '-{{amount_saved_percentage}}', { amount_saved_percentage: pct + '%' }) + '</span></span>'
      : '';

    var oldPrice = ca ? '<s class="wx-item__total-old">' + money(ca * item.quantity) + '</s>' : '';

    return '' +
      '<div class="wx-item" data-wx-item data-key="' + esc(item.key) + '">' +
        '<div class="wx-item__image-container">' +
          '<a class="wx-item__link" href="' + esc(item.url) + '" tabindex="-1">' +
            '<img class="wx-item__image" src="' + esc(imgSize(item.image, 160)) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="80" height="80">' +
          '</a>' +
        '</div>' +
        '<div class="wx-item__content">' +
          '<div class="wx-item__content-left">' +
            '<div class="wx-item__info">' +
              '<a class="wx-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              optionNames +
              selectors +
            '</div>' +
            '<div class="wx-item__quantity">' +
              '<button type="button" class="wx-qty-btn" data-wx-qty="-1" data-key="' + esc(item.key) + '" aria-label="Decrease quantity">' + ICONS.minus + '</button>' +
              '<input class="wx-qty-input" type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-wx-qty-input data-key="' + esc(item.key) + '" aria-label="Quantity">' +
              '<button type="button" class="wx-qty-btn" data-wx-qty="1" data-key="' + esc(item.key) + '" aria-label="Increase quantity">' + ICONS.plus + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="wx-item__content-right">' +
            '<div class="wx-item__price-info">' +
              oldPrice +
              '<span class="wx-item__total-final">' + money(item.final_line_price) + '</span>' +
              badge +
            '</div>' +
            '<button type="button" class="wx-item__remove" data-wx-remove data-key="' + esc(item.key) + '" aria-label="Remove this item">' + ICONS.trash + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderEmpty() {
    return '<div class="wx-cart__empty">' + ICONS.bag +
      '<p class="wx-cart__empty-title">' + esc(T.emptyTitle || 'Your cart is empty') + '</p>' +
      '<button type="button" class="wx-checkout" data-wx-close style="max-width:260px">' + esc(T.emptyButton || 'Continuer mes achats') + '</button>' +
      '</div>';
  }

  function renderUpsellSlide(p) {
    var v = p.__variant || p.variants[0];
    var ca = v.compare_at_price && Number(v.compare_at_price) > v.price ? Number(v.compare_at_price) : 0;
    var pct = ca ? Math.round((ca - v.price) / ca * 100) : 0;
    var hasOptions = p.options && p.options.length &&
      !(p.options.length === 1 && String(typeof p.options[0] === 'string' ? p.options[0] : p.options[0].name).toLowerCase() === 'title');

    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var selectors = '';
    if (hasOptions) {
      selectors = '<div class="wx-upsell-item__selectors">' + names.map(function (name, idx) {
        var values = [];
        p.variants.forEach(function (vv) { if (values.indexOf(vv.options[idx]) === -1) values.push(vv.options[idx]); });
        return '<select class="wx-select" data-wx-upsell-select data-handle="' + esc(p.handle) + '" data-index="' + idx + '" aria-label="' + esc(name) + '">' +
          values.map(function (val) {
            return '<option value="' + esc(val) + '"' + (String(val) === String(v.options[idx]) ? ' selected' : '') + '>' + esc(val) + '</option>';
          }).join('') + '</select>';
      }).join('') + '</div>';
    }

    return '<div class="wx-upsell__slide"><div class="wx-upsell__card"><div class="wx-upsell-item">' +
      '<img class="wx-upsell-item__image" src="' + esc(imgSize(v.featured_image && v.featured_image.src || p.featured_image, 120)) + '" alt="' + esc(p.title) + '" loading="lazy" width="60" height="60">' +
      '<div class="wx-upsell-item__content">' +
        '<a class="wx-upsell-item__title" href="' + esc(u('products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
        '<div class="wx-upsell-item__prices">' +
          '<span class="wx-upsell-item__price-final">' + money(v.price) + '</span>' +
          (ca ? '<s class="wx-upsell-item__price-old">' + money(ca) + '</s>' : '') +
          (pct > 0 ? '<span class="wx-badge"><span>' + tpl(T.youSave || '-{{amount_saved_percentage}}', { amount_saved_percentage: pct + '%' }) + '</span></span>' : '') +
        '</div>' +
        (hasOptions ? '<span class="wx-upsell-item__options">' + esc(names.join(', ')) + ':</span>' : '') +
        selectors +
        '<button type="button" class="wx-upsell-item__add" data-wx-upsell-add data-handle="' + esc(p.handle) + '"' + (v.available ? '' : ' disabled') + '>' +
          esc(v.available ? (T.addToCart || 'Add to cart') : (T.outOfStock || 'Sold out')) + '</button>' +
      '</div>' +
    '</div></div></div>';
  }

  function renderUpsell() {
    if (!CFG.upsell || !CFG.upsell.active) return '';
    if (!state.recs || !state.recs.length) return '';
    return '<div class="wx-upsell is-ready" data-wx-upsell>' +
      '<p class="wx-upsell__title">' + esc(CFG.upsell.title || '') + '</p>' +
      '<div class="wx-upsell__viewport">' +
        '<button type="button" class="wx-upsell__arrow" data-wx-upsell-prev aria-label="Precedent">' + ICONS.arrowLeft + '</button>' +
        '<div class="wx-upsell__track" data-wx-upsell-track>' + state.recs.map(renderUpsellSlide).join('') + '</div>' +
        '<button type="button" class="wx-upsell__arrow" data-wx-upsell-next aria-label="Suivant">' + ICONS.arrowRight + '</button>' +
      '</div>' +
    '</div>';
  }

  function renderAddon() {
    var a = CFG.addon;
    if (!a || !a.active) return '';
    var on = !!addonLine();
    return '<div class="wx-addon">' +
      (a.image ? '<img class="wx-addon__image" src="' + esc(imgSize(a.image, 160)) + '" alt="" loading="lazy">' : '') +
      '<div class="wx-addon__content">' +
        '<div class="wx-addon__top">' +
          '<span class="wx-addon__title">' + esc(a.title) + '</span>' +
          '<span class="wx-addon__price">' + money(a.price) + '</span>' +
          '<button type="button" class="wx-toggle" data-wx-addon-toggle aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + esc(a.title) + '"><span class="wx-toggle__handle"></span></button>' +
        '</div>' +
        (a.description ? '<p class="wx-addon__description">' + esc(a.description) + '</p>' : '') +
      '</div>' +
    '</div>';
  }

  function renderFooter() {
    if (!state.cart || !state.cart.item_count) return '';
    var t = totals();
    var rows = '';
    if (t.savings > 0) {
      rows += '<div class="wx-row wx-row--discounts"><span>' + esc(T.discounts || 'Reductions') + '</span><span>-' + money(t.savings) + '</span></div>';
    }
    rows += '<div class="wx-row wx-row--subtotal"><span>' + esc(T.subtotal || 'Subtotal') + '</span><span>' + money(t.subtotal) + '</span></div>';

    return renderAddon() + rows +
      '<button type="button" class="wx-checkout" data-wx-checkout>' +
        tpl(esc(T.checkoutButton || 'CHECKOUT'), { cart_total: money(t.subtotal) }) +
      '</button>' +
      (CFG.paymentIconsHtml ? '<div class="wx-payment-icons">' + CFG.paymentIconsHtml + '</div>' : '') +
      '<button type="button" class="wx-secondary" data-wx-close>' + esc(T.secondaryButton || 'Continuer mes achats') + '</button>';
  }

  function render() {
    if (!el.root || !state.cart) return;
    var lines = cartLines();
    el.heading.textContent = tpl(T.topBar || 'Your cart • {{item_count}}', { item_count: displayCount() });

    if (!lines.length) {
      el.contents.innerHTML = renderEmpty();
      el.footer.innerHTML = '';
      el.footer.style.display = 'none';
      return;
    }
    el.footer.style.display = '';
    var scroll = el.contents.scrollTop;
    el.contents.innerHTML = lines.map(renderItem).join('') + renderUpsell();
    el.footer.innerHTML = renderFooter();
    el.contents.scrollTop = scroll;
    syncThemeCount();
  }

  // ------------------------------------------------------- compteur du theme
  function syncThemeCount() {
    var n = (state.cart && state.cart.item_count) || 0;
    document.querySelectorAll('[data-cart-count], .cart-link__bubble-num, .header__cart-count').forEach(function (node) {
      node.textContent = n;
    });
    document.querySelectorAll('[data-header-cart-count]').forEach(function (node) { node.textContent = n; });
    try {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: state.cart } }));
    } catch (e) {}
  }

  // ---------------------------------------------------------- recommandations
  function refreshRecs() {
    if (!CFG.upsell || !CFG.upsell.active) return Promise.resolve();
    var lines = cartLines();
    if (!lines.length) { state.recs = null; state.recsForKey = null; return Promise.resolve(); }
    var seed = lines[0].product_id;
    var inCart = lines.map(function (i) { return String(i.product_id); });
    var key = seed + '|' + inCart.join(',');
    if (state.recsForKey === key) return Promise.resolve();

    return fetch(u('recommendations/products.json?product_id=' + seed + '&limit=10&intent=related'))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var list = (data && data.products) || [];
        list = list.filter(function (p) {
          if (CFG.addon && String(p.id) === String(CFG.addon.productId)) return false;
          if (inCart.indexOf(String(p.id)) !== -1) return false;
          return p.available !== false;
        }).slice(0, 8);
        list.forEach(function (p) {
          state.products[p.handle] = p;
          for (var i = 0; i < p.variants.length; i++) {
            if (p.variants[i].available) { p.__variant = p.variants[i]; break; }
          }
          if (!p.__variant) p.__variant = p.variants[0];
        });
        state.recs = list;
        state.recsForKey = key;
      })
      .catch(function () { state.recs = null; });
  }

  // ------------------------------------------------------------ cycle de vie
  function setBusy(v) {
    state.busy = v;
    if (el.root) el.root.classList.toggle('is-busy', !!v);
  }

  function pull() {
    return fetch(u('cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.cart = cart;
        return loadCartProducts(cart);
      })
      .then(refreshRecs)
      .then(render);
  }

  function mutate(promise) {
    setBusy(true);
    return promise
      .then(function () { return pull(); })
      .catch(function () { return pull(); })
      .then(function () { setBusy(false); });
  }

  function changeLine(key, quantity) {
    return mutate(json(u('cart/change.js'), {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity })
    }));
  }

  function addVariant(id, quantity) {
    return mutate(json(u('cart/add.js'), {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    }));
  }

  function swapVariant(key, newVariantId, quantity) {
    setBusy(true);
    return json(u('cart/change.js'), { method: 'POST', body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function () {
        return json(u('cart/add.js'), { method: 'POST', body: JSON.stringify({ items: [{ id: Number(newVariantId), quantity: quantity }] }) });
      })
      .catch(function () {})
      .then(function () { return pull(); })
      .then(function () { setBusy(false); });
  }

  // ------------------------------------------------------------ ouverture
  function open() {
    if (!el.root) return;
    state.open = true;
    el.root.classList.add('is-open');
    document.documentElement.classList.add('wx-cart-open');
    document.body.style.overflow = 'hidden';
    pull();
  }

  function close() {
    if (!el.root) return;
    state.open = false;
    el.root.classList.remove('is-open');
    document.documentElement.classList.remove('wx-cart-open');
    document.body.style.overflow = '';
  }

  // ------------------------------------------------------------ evenements
  // --------------------------------------------------------------- carrousel
  // Chrome refuse un defilement « smooth » sur un conteneur en scroll-snap
  // mandatory : il re-aimante aussitot sur la position de depart. On anime
  // donc nous-memes, snap desactive le temps de l'animation.
  function pageCarousel(track, dir) {
    if (!track) { return; }
    var w = track.clientWidth;
    if (!w) { return; }
    var max = track.scrollWidth - w;
    track.scrollLeft = Math.max(0, Math.min(max, (Math.round(track.scrollLeft / w) + dir) * w));
  }

  function bind() {
    el.root.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-wx-close]') || t.closest('.wx-cart__overlay')) {
        e.preventDefault(); close(); return;
      }

      var qty = t.closest('[data-wx-qty]');
      if (qty) {
        e.preventDefault();
        if (state.busy) return;
        var key = qty.getAttribute('data-key');
        var delta = Number(qty.getAttribute('data-wx-qty'));
        var line = (state.cart.items || []).filter(function (i) { return i.key === key; })[0];
        if (!line) return;
        changeLine(key, Math.max(0, line.quantity + delta));
        return;
      }

      var rm = t.closest('[data-wx-remove]');
      if (rm) {
        e.preventDefault();
        if (state.busy) return;
        changeLine(rm.getAttribute('data-key'), 0);
        return;
      }

      var tg = t.closest('[data-wx-addon-toggle]');
      if (tg) {
        e.preventDefault();
        if (state.busy) return;
        var existing = addonLine();
        if (existing) changeLine(existing.key, 0);
        else addVariant(CFG.addon.variantId, 1);
        return;
      }

      var add = t.closest('[data-wx-upsell-add]');
      if (add) {
        e.preventDefault();
        if (state.busy) return;
        var p = state.products[add.getAttribute('data-handle')];
        if (!p) return;
        var v = p.__variant || p.variants[0];
        if (!v || !v.available) return;
        addVariant(v.id, 1);
        return;
      }

      var co = t.closest('[data-wx-checkout]');
      if (co) {
        e.preventDefault();
        if (state.busy) return;
        co.setAttribute('disabled', 'disabled');
        window.location.href = u('checkout');
        return;
      }

      var prev = t.closest('[data-wx-upsell-prev]');
      var next = t.closest('[data-wx-upsell-next]');
      if (prev || next) {
        e.preventDefault();
        var track = el.root.querySelector('[data-wx-upsell-track]');
        if (track) pageCarousel(el.root.querySelector('[data-wx-upsell-track]'), next ? 1 : -1);
        return;
      }
    });

    el.root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-wx-variant-select]');
      if (sel) {
        if (state.busy) return;
        var key = sel.getAttribute('data-key');
        var line = (state.cart.items || []).filter(function (i) { return i.key === key; })[0];
        if (!line) return;
        var product = state.products[line.handle];
        var selects = el.root.querySelectorAll('[data-wx-variant-select][data-key="' + key + '"]');
        var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = findVariant(product, opts);
        if (!v) { render(); return; }
        if (String(v.id) === String(line.variant_id)) return;
        swapVariant(key, v.id, line.quantity);
        return;
      }

      var usel = e.target.closest('[data-wx-upsell-select]');
      if (usel) {
        var handle = usel.getAttribute('data-handle');
        var prod = state.products[handle];
        if (!prod) return;
        var ss = el.root.querySelectorAll('[data-wx-upsell-select][data-handle="' + handle + '"]');
        var o = Array.prototype.map.call(ss, function (s) { return s.value; });
        var found = findVariant(prod, o);
        if (found) { prod.__variant = found; render(); }
        return;
      }
    });

    el.root.addEventListener('keydown', function (e) {
      var inp = e.target.closest('[data-wx-qty-input]');
      if (inp && e.key === 'Enter') { e.preventDefault(); inp.blur(); }
    });

    el.root.addEventListener('blur', function (e) {
      var inp = e.target.closest && e.target.closest('[data-wx-qty-input]');
      if (!inp || state.busy) return;
      var key = inp.getAttribute('data-key');
      var line = (state.cart.items || []).filter(function (i) { return i.key === key; })[0];
      if (!line) return;
      var q = parseInt(inp.value, 10);
      if (isNaN(q) || q < 0) q = line.quantity;
      if (q !== line.quantity) changeLine(key, q);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) close();
    });
  }

  // -------------------------------- remplacement du tiroir natif du theme
  function takeOver() {
    document.documentElement.classList.add('wx-cart-active');

    // 1. neutraliser le tiroir de Palo Alto
    function patchPrototype() {
      var CD = window.PaloAlto && window.PaloAlto.CartDrawer;
      var P = CD && CD.prototype;
      if (!P || P.__wxTakenOver) return !!P;
      ['openCartDrawer', 'toggleCartDrawer'].forEach(function (m) {
        if (typeof P[m] !== 'function') return;
        P[m] = function () { open(); };
      });
      ['renderCartDrawer', 'build', 'getCart', 'buildTotalPrice', 'buildCartTotalDiscounts',
       'renderPairProducts', 'updateItemsQuantity', 'toggleClassesOnContainers'].forEach(function (m) {
        if (typeof P[m] !== 'function') return;
        P[m] = function () { return Promise.resolve(); };
      });
      P.__wxTakenOver = true;
      return true;
    }
    if (!patchPrototype()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (patchPrototype() || ++tries > 120) clearInterval(timer);
      }, 100);
    }

    // 2. intercepter les declencheurs du panier
    var TRIGGERS = [
      '[data-cart-drawer-toggle]', '[data-cart-toggle]', '.cart-link', '.cart-link__icon',
      'a[href$="/cart"]', 'a[href*="/cart?"]', '[data-drawer-toggle="cart"]'
    ].join(',');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(TRIGGERS);
      if (!trigger) return;
      if (el.root && el.root.contains(trigger)) return;
      var href = trigger.getAttribute('href') || '';
      if (/\/cart\/(add|change|update|clear)/.test(href)) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open();
    }, true);

    // 3. suivre toutes les mutations du panier faites par le theme
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var isMutation = isAdd || /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);
      var p = origFetch.apply(this, arguments);
      if (!isMutation) return p;
      return p.then(function (res) {
        if (!el.root || el.root.contains(document.activeElement)) { /* mutation interne */ }
        setTimeout(function () {
          pull().then(function () { if (isAdd) open(); });
        }, 0);
        return res;
      });
    };

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__wxUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      var url = self.__wxUrl || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        self.addEventListener('load', function () {
          var isAdd = /\/cart\/add/.test(url);
          setTimeout(function () { pull().then(function () { if (isAdd) open(); }); }, 0);
        });
      }
      return origSend.apply(this, arguments);
    };

    // 4. formulaires d'ajout classiques (non-ajax)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;
      e.preventDefault();
      var fd = new FormData(form);
      setBusy(true);
      fetch(u('cart/add.js'), { method: 'POST', body: fd })
        .then(function () { return pull(); })
        .then(function () { setBusy(false); open(); })
        .catch(function () { setBusy(false); });
    }, true);
  }

  // ------------------------------------------------------------------ init
  function init() {
    el.root = document.querySelector('[data-wx-cart]');
    if (!el.root) return;
    el.heading = el.root.querySelector('[data-wx-heading]');
    el.contents = el.root.querySelector('[data-wx-contents]');
    el.footer = el.root.querySelector('[data-wx-footer]');

    bind();
    takeOver();

    if (window.__wxInitialCart) {
      state.cart = window.__wxInitialCart;
      loadCartProducts(state.cart).then(refreshRecs).then(render);
    } else {
      pull();
    }

    window.WXCart = { open: open, close: close, refresh: pull, state: state };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
